﻿window.cObjetTvaMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "TVA"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvelle tva"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined' && objet.data.nom != null && objet.data.nom.length > 0) { txt = objet.data.nom }
        else {
            txt = "..."
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-percent' title='TVA'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

        $TableMenu = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($TableMenu)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var dxBtNewTva = $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-percent",
            icon2: "fas fa-certificate",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            txtTooltip: "Créer une nouvelle TVA",
            height: HeightEntete - 2,
            width: HeightEntete - 2,
            onClick: function (e) {
                Me.mShowPopupTva(Me.objet.bddRef.getObjet("tva").mGetNewData());
            }
        }).dxCtrlButton("instance")
        $DivGrid = $("<div style='width:100%;height:calc(100% - " + $TableMenu.innerHeight() + "px);'/>").appendTo(contentElement)

        var optGrid = {
            bddCtrl: Me.objet.bddRef,
            getHeight: function () { return contentElement.innerHeight() - $TableMenu.innerHeight() },
            getMaxHeight: function () { return contentElement.innerHeight() - $TableMenu.innerHeight() },
            height: contentElement.innerHeight() - $TableMenu.innerHeight(),
            //dataSource: new DevExpress.data.DataSource({
            //    store: Me.objet.bddRef.mGetStore("tva"),
            //    reshapeOnPush: true
            //}),
            dataSource: new DevExpress.data.DataSource({
                store: new DevExpress.data.ArrayStore({
                    key: "id_tva",
                    data: Me.objet.bddRef.mGetStore("tva").array
                }),
                reshapeOnPush: true
            }),
            showColumnHeaders: false,
            width: "100%",
            noDataText: "Aucune TVA",
            hoverStateEnabled: true,
            selection: { mode: "single" },
            onKeyDown: function (e) { if (e.event.keyCode == 13) e.handled = true; },
            columns: [{
                dataType: 'string', width: 55,
                cellTemplate: function (cellElement, cellInfo) {
                    cellElement.css("font-size", '150%')
                    //cellElement.css("padding-left", '5px')
                    //cellElement.css("padding-right", '5px')
                    var objApp = Me.objet.bddRef.getObjet(cellInfo.data)
                    objApp.mGetIcone().appendTo(cellElement);
                }
            }, {
                dataField: "nom", caption: "Nom TVA", dataType: 'string',
                cellTemplate: function (cellElement, cellInfo) {
                    $("<div/>").appendTo(cellElement).dxCtrlTextBox({
                        value: cellInfo.data.nom,
                        label: "Nom TVA",
                        placeholder: "Nom de la TVA...",
                        labelMode: 'floating',
                        disabled: false, // disabled: (cellInfo.data.id_tva == 5),
                        inputAttr: { autocomplete: 'test-autocomplete' },
                        onValueChanged: function (e) {
                            if (e.value == null || e.value.length == 0) {
                                window.setTimeout(function () { mNotify("Vous devez saisir un nom pour la TVA", "warning", 6000) }, 0)
                                e.component.option("value", cellInfo.data.nom)
                            } else {
                                if (cellInfo.data.nom != e.value) {
                                    cellInfo.data.nom = e.value
                                    Me.objet.bddRef.getObjet(cellInfo.data).mSaveChamp("nom")
                                }
                            }
                        }
                    })
                }
            }, {
                dataField: "taux", caption: "taux", dataType: 'string', width: 150,
                cellTemplate: function (cellElement, cellInfo) {
                    $("<div/>").appendTo(cellElement).dxCtrlNumberBox({
                        labelMode: 'floating',
                        label: "Taux",
                        disabled: (cellInfo.data.id_tva == 5),
                        isFloat: true,
                        noNull: true,
                        unite_mesure: "%",
                        value: cellInfo.data.taux,
                        placeholder: "Saisissez le taux de tva en pourcentage...",
                        onValueChanged: function (e) {
                            cellInfo.data.taux = e.value
                            Me.objet.bddRef.getObjet(cellInfo.data).mSaveChamp("taux")
                        }
                    }).dxCtrlNumberBox("instance")
                }
            }, {
                dataField: "plan_comptable", caption: "Plan comptable", dataType: 'string', width: 150,
                cellTemplate: function (cellElement, cellInfo) {
                    $("<div/>").appendTo(cellElement).dxCtrlPlanComptable({
                        bddCtrl: Me.objet.bddRef,
                        labelMode: 'floating',
                        label: "Taux",
                        dataSource: ["4457"],
                        value: cellInfo.data.plan_comptable,
                        placeholder: "Saisissez le taux de tva en pourcentage...",
                        onValueChanged: function (e) {
                            debugger;
                            cellInfo.data.plan_comptable = e.value
                            Me.objet.bddRef.getObjet(cellInfo.data).mSaveChamp("plan_comptable")
                        }
                    }).dxCtrlNumberBox("instance")
                }
            }],
            iconeElement: "fas fa-percent"
        }

        var dxGrid = $("<div/>").appendTo($DivGrid).dxCtrlGridSimple(optGrid).dxCtrlGridSimple("instance");

        Me.objet.bddRef.mAddFunctionOnModifiedItemData("tva", dxGrid.element(), function (action, itemData, nomChamp) {
            dxGrid.refresh(false)
        })
    }

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
    }

    typeTva = [{ id_type_tva: 1, libelle: "Taux normal" },
    { id_type_tva: 2, libelle: "Taux intermédiaire" },
    { id_type_tva: 3, libelle: "Taux réduit" },
    { id_type_tva: 4, libelle: "Taux particulier" },
    { id_type_tva: 5, libelle: "Taux 0" }]
    this.mGetTvaFromType = function (idTypeTva) {
        var tva = Me.objet.bddRef.mGetArray("tva").filter(function (tva) { return tva.id_type_tva == idTypeTva })[0]
        return ((typeof tva == 'undefined') ? null : tva)
    }

    this.mGetTvaTaux0 = function () {
        var tva = Me.objet.bddRef.mGetArray("tva").filter(function (tva) { return tva.id_type_tva == 5 })[0]
        return ((typeof tva == 'undefined') ? null : tva)
    }

    this.mShowPopupTva = function (dataTva) {
        var pop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupBase({
            title: ((dataTva.id_tva == null) ? "Nouvelle TVA" : "Modifier TVA"),
            showMaximize: false,
            height: 280,
            width: 360,
            contentTemplate: function (contentElement) {
                var dxNom = null
                var dxTaux = null
                var items = [{
                    dataField: "nom", name: "nom", label: { visible: false, text: "Nom", location: "left" },
                    template: function (itemData, itemElement) {
                        dxNom = $("<div class='dxctrlfocus'/>").appendTo(itemElement).dxCtrlTextBox({
                            value: dataTva.nom,
                            label: "Nom",
                            placeholder: "Nom de la tva...",
                            labelMode: 'floating',
                            inputAttr: { autocomplete: 'test-autocomplete' },
                            onValueChanged: function (e) {
                                dataTva.nom = e.value;
                            }
                        }).dxCtrlTextBox("instance")
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                }, {
                    dataField: "taux", name: "taux", label: { visible: false, text: "Taux", location: "left" },
                    template: function (itemData, itemElement) {
                        dxTaux = $("<div/>").appendTo(itemElement).dxCtrlNumberBox({
                            labelMode: 'floating',
                            label: "Taux TVA",
                            unite_mesure: "%",
                            isFloat: true,
                            noNull: true,
                            value: dataTva.taux,
                            placeholder: "Taux de TVA en pourcentage...",
                            onValueChanged: function (e) {
                                dataTva.taux = e.value
                            }
                        }).dxCtrlNumberBox("instance");
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                }]
                var form = $("<div style='padding-bottom:15px'/>").appendTo(contentElement).dxCtrlForm({
                    labelMode: 'floating',
                    showColonAfterLabel: true,
                    labelLocation: 'left',
                    formData: dataTva,
                    items: items
                }).dxCtrlForm("instance");
                mAddButtonOkAnnuler(contentElement,
                    function () { //ok
                        if (dxNom.option("value") == null || dxNom.option("value").length == 0) {
                            mNotify("Vous devez saisir un nom pour la TVA", "warning", 6000)
                            dxNom.focus()
                            return
                        }
                        Me.objet.bddRef.getObjet(dataTva).mSave()
                        pop.hide()
                    },
                    function () { //annuler
                        pop.hide();
                    })
            }
        }).dxCtrlPopupBase("instance")
        pop.show();
    }

    this.mShowPopupLstTva = function () {
        var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
            width: 500,
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            title: "TVA",
            showMaximize: false,
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "5px")
                Me.contentTemplateGrid(contentElement, {})
            }
        }).dxCtrlPopupBase("instance")
        pop.verifOnHiding = true
        pop.show();
    }

    this.isPopupFullScreen = false
    //this.mShowPopup = function (optionPopup) {

    //}

    this.mGetTauxTva = function () {
        return ((typeof objet.data == 'undefined') ? 0 : parseFloat(objet.data.taux))
        //var dataTauxTva = this.mGetDataTauxTva()
        //if (typeof dataTauxTva == 'undefined') {
        //    var tva = this.mGetDataTva()
        //    if (typeof tva == 'undefined') { return 0 } else { return parseFloat(tva.taux) }
        //} else { return parseFloat(dataTauxTva.taux) }
    }
    //this.mGetDataTauxTva = function () {
    //    var dataTauxTva = Me.objet.bddRef.mGetArray("tva_taux").filter(function (o) { return o.id_tva == objet.data.id_tva && parametre.dateNow >= o.date_debut && parametre.dateNow <= o.date_fin })[0]
    //    if (typeof dataTauxTva == 'undefined') {
    //        dataTauxTva = Me.objet.bddRef.mGetArray("tva_taux").filter(function (o) { return o.id_tva == objet.data.id_tva }).sort(function (o1, o2) { return o2.date_fin - o1.date_fin })[0]
    //    }
    //    return dataTauxTva
    //}

}